import { render, staticRenderFns } from "./familyInfo.vue?vue&type=template&id=0add62c2&scoped=true&"
import script from "./familyInfo.vue?vue&type=script&lang=js&"
export * from "./familyInfo.vue?vue&type=script&lang=js&"
import style0 from "./familyInfo.vue?vue&type=style&index=0&id=0add62c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0add62c2",
  null
  
)

export default component.exports